export function setReactInputValue(element, val) {
    var _a, _b;
    var valueSetter = (_a = Object === null || Object === void 0 ? void 0 : Object.getOwnPropertyDescriptor(element, 'value')) === null || _a === void 0 ? void 0 : _a.set;
    var prototype = Object.getPrototypeOf(element);
    var prototypeValueSetter = (_b = Object === null || Object === void 0 ? void 0 : Object.getOwnPropertyDescriptor(prototype, 'value')) === null || _b === void 0 ? void 0 : _b.set;
    /* The else case is for IE11 only */
    /* istanbul ignore else */
    if (valueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter === null || prototypeValueSetter === void 0 ? void 0 : prototypeValueSetter.call(element, val);
    }
    else {
        valueSetter === null || valueSetter === void 0 ? void 0 : valueSetter.call(element, val);
    }
    // 'change' instead of 'input', see https://github.com/facebook/react/issues/11488#issuecomment-381590324
    var event;
    /* The else case is for IE11 only */
    /* istanbul ignore else */
    if (typeof Event === 'function') {
        event = new Event('change', { bubbles: true });
    }
    else {
        event = document.createEvent('Event');
        event.initEvent('change', true, true);
    }
    element.dispatchEvent(event);
}
//# sourceMappingURL=changeEvent.js.map